module.exports = fox._r("images/faq/form_bg.jpg", __webpack_public_path__ + "images/faq/form_bg.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/faq/form_bg.jpg
// module id = 154
// module chunks = 5